import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {inject, observer} from 'mobx-react';
import {
    UNDER_MAINTENANCE_FLAG,
    CONNECTION_ISSUE_ALERT,
    UNDER_MAINTENANCE_ALERT,
    SHOP_CLOSED_WITH_ORDERS_FLAG,
    SHOP_CLOSED_WITH_ORDERS_ALERT
} from '../../constants';

const liveOrderStreamHeader = {
    "lineHeight": "22pt",
    "textAlign": "center",
    "background": "rgb(38, 38, 50)",
    "display": "flex",
    "justifyContent": "center"
};

const errorMsgTitle = {
    "fontFamily": "GraphikSemiBold",
    "letterSpacing": "1%",
    "fontSize": "2em",
    "color": "white",
    "width": "100%",
    "textAlign": "center",
};

const errorMsg = {
    "fontFamily": "GraphikLight",
    "letterSpacing": "1%",
    "fontSize": "1.5em",
    "color": "white",
    "width": "100%",
    "textAlign": "center",
    "marginTop": '2rem'
};

const openHours = {
    "fontFamily": "GraphikSemiBold",
    "letterSpacing": "1%",
    "fontSize": "1.4em",
    "color": "white",
    "width": "100%",
    "textAlign": "center",
    "marginTop": '1.7rem'
};
function getErrorProps(alertString){
    switch (alertString) {
        case SHOP_CLOSED_WITH_ORDERS_FLAG:
            return SHOP_CLOSED_WITH_ORDERS_ALERT
        case UNDER_MAINTENANCE_FLAG:
            return UNDER_MAINTENANCE_ALERT
        default:
            return CONNECTION_ISSUE_ALERT
    }
}

@inject('RootStore')
@observer
export default class OrderStreamWidgetAlert extends Component {
    render() {
        const {nextShopStateChange, formattedNextShopStateChange} = this.props.RootStore.configStore
        let errorMsgObject = getErrorProps(this.props.alertString);
        return (
            <Flexbox flexDirection="row" justifyContent={"center"} width="100%" height="100%">
                <Flexbox flexDirection="column" width="100%" height="100%" style={liveOrderStreamHeader}>
                    <div style={errorMsgTitle}>
                        {errorMsgObject.title}
                    </div>
                    {errorMsgObject.desc && <div style={errorMsg}>
                        {errorMsgObject.desc}
                    </div>}
                    {errorMsgObject.showOpenHours && nextShopStateChange &&
                    <div style={openHours}>
                        Shop reopens {formattedNextShopStateChange}
                    </div>}
                </Flexbox>
            </Flexbox>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/alerts/order_stream_widget_alert.jsx